import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import styled, { css } from 'styled-components';
import colors from '../../colors';
import breakpoints from '../../breakpoints';
import BigEggLogo from './BigEggLogo';
import { getBigEggHeaderLogoWidthByProductName } from '../shared';
var ResizedHeaderLogo = styled(BigEggLogo).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['resize'].includes(prop);
  }
}).withConfig({
  displayName: "BigEggHeaderLogo__ResizedHeaderLogo",
  componentId: "s3fb80-0"
})(["height:30px;width:", "px;", ""], function (_ref) {
  var productName = _ref.productName;
  return getBigEggHeaderLogoWidthByProductName(productName);
}, function (_ref2) {
  var resize = _ref2.resize,
      productName = _ref2.productName;
  return resize ? css(["@media screen and (max-width:", "){height:20px;width:", "px;}"], breakpoints.md.max, Math.round(getBigEggHeaderLogoWidthByProductName(productName) * 0.66667)) : '';
});
/**
 * Renders Chegg product logos in Chegg orange and dimensions appropriate for the sitewide header.
 */

var BigEggHeaderLogo = function BigEggHeaderLogo(_ref3) {
  var _ref3$role = _ref3.role,
      role = _ref3$role === void 0 ? 'img' : _ref3$role,
      _ref3$svgColor = _ref3.svgColor,
      svgColor = _ref3$svgColor === void 0 ? colors.cheggOrange : _ref3$svgColor,
      _ref3$resize = _ref3.resize,
      resize = _ref3$resize === void 0 ? true : _ref3$resize,
      rest = _objectWithoutProperties(_ref3, ["role", "svgColor", "resize"]);

  return /*#__PURE__*/React.createElement(ResizedHeaderLogo, _extends({
    role: role,
    svgColor: svgColor,
    resize: resize
  }, rest));
};

BigEggHeaderLogo.displayName = 'BigEggHeaderLogo';
export default BigEggHeaderLogo;